import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle } from 'lucide-react';
export function UrgencyTimer() {
  // Start with 23:27:35 in seconds
  const initialTime = 23 * 3600 + 27 * 60 + 35;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return {
      hours: h.toString().padStart(2, '0'),
      minutes: m.toString().padStart(2, '0'),
      seconds: s.toString().padStart(2, '0')
    };
  };
  const {
    hours,
    minutes,
    seconds
  } = formatTime(timeLeft);
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-red-950/30 border-y border-red-900/50" data-id="element-375">
      <div className="max-w-3xl mx-auto text-center" data-id="element-376">
        <motion.div animate={{
        scale: [1, 1.05, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="inline-flex items-center gap-2 text-red-500 font-bold mb-6" data-id="element-377">
          <Clock className="w-5 h-5" data-id="element-378" />
          PRECIO DE LANZAMIENTO — CIERRA EN:
        </motion.div>

        <div className="flex justify-center gap-4 mb-8" data-id="element-379">
          <div className="bg-slate-900 border border-red-900/50 rounded-xl p-4 w-24 shadow-lg shadow-red-900/20" data-id="element-380">
            <div className="text-4xl font-black text-white tabular-nums" data-id="element-381">
              {hours}
            </div>
            <div className="text-xs text-red-400 font-bold mt-1" data-id="element-382">HS</div>
          </div>
          <div className="text-4xl font-black text-red-500/50 self-center pb-6" data-id="element-383">
            :
          </div>
          <div className="bg-slate-900 border border-red-900/50 rounded-xl p-4 w-24 shadow-lg shadow-red-900/20" data-id="element-384">
            <div className="text-4xl font-black text-white tabular-nums" data-id="element-385">
              {minutes}
            </div>
            <div className="text-xs text-red-400 font-bold mt-1" data-id="element-386">MIN</div>
          </div>
          <div className="text-4xl font-black text-red-500/50 self-center pb-6" data-id="element-387">
            :
          </div>
          <div className="bg-slate-900 border border-red-900/50 rounded-xl p-4 w-24 shadow-lg shadow-red-900/20" data-id="element-388">
            <div className="text-4xl font-black text-white tabular-nums" data-id="element-389">
              {seconds}
            </div>
            <div className="text-xs text-red-400 font-bold mt-1" data-id="element-390">SEG</div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-amber-400 font-medium mb-6 bg-amber-500/10 py-2 px-4 rounded-lg inline-flex" data-id="element-391">
          <AlertTriangle className="w-5 h-5" data-id="element-392" />
          Después sube $5.000 ARS. No vuelve.
        </div>

        <div className="max-w-md mx-auto" data-id="element-393">
          <div className="flex justify-between text-sm font-bold mb-2" data-id="element-394">
            <span className="text-red-400 flex items-center gap-1" data-id="element-395">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-396"></span>{' '}
              Cupos al precio de lanzamiento
            </span>
            <span className="text-slate-400" data-id="element-397">Quedan pocos</span>
          </div>
          <div className="h-4 bg-slate-800 rounded-full overflow-hidden border border-slate-700" data-id="element-398">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-gradient-to-r from-red-600 to-red-500 relative" data-id="element-399">
              <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.15)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.15)_50%,rgba(255,255,255,0.15)_75%,transparent_75%,transparent)] bg-[length:1rem_1rem] animate-[progress_1s_linear_infinite]" data-id="element-400" />
            </motion.div>
          </div>
          <p className="text-xs text-slate-400 mt-2 text-right" data-id="element-401">
            68% de los cupos ya tomados
          </p>
        </div>
      </div>
    </section>;
}